import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { zachJohnson } from "@/lib/celebrity-results/zach-johnson";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Zach Johnson Hair Transplant Results | RESTORE Hair";
const DESC = "Learn why Zach Johnson came to RESTORE to get his hair restoration. See behind the scene photos and videos directly from Zach.";
const POSTER = "/img/r/wp-2024-08-restore-zachjohnson-1-768x512-3.webp";

export const Route = createFileRoute("/results/zach-johnson")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/zach-johnson/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/zach-johnson/" },
    ],
  }),
  component: () => <CelebrityResultPage data={zachJohnson} />,
});
